export default __webpack_public_path__ + "static/Gotham-Book-1c84b66d1d7e5c1598f348a919ed1686.woff2";